// @ts-nocheck legacy file transformed to TS
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Icon, colors } from 'ic-snacks'
import FlexRow from 'legacy/components/FlexRow'

const Container = styled(FlexRow)`
  position: relative;
  width: 200px;
  flex-grow: 1;
  background: #f7f7f7;
  border: 1px solid ${colors.GRAY_88};
  border-radius: 4px;
  padding: 10px 0px;
  padding-left: 20px;
  padding-right: 10px;
  margin: 0 10px;
  height: 42px;
`

const Input = styled.input`
  outline: none;
  font-size: 14px;
  border: none;
  background: transparent;
  flex: 1;
  ::placeholder {
    color: ${colors.GRAY_46};
  }
`

const iconStyle = {
  fontSize: '20px',
  cursor: 'pointer',
  color: colors.GREEN_500,
}

class SearchBar extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
  }

  static defaultProps = {
    placeholder: 'Search',
  }

  onKeyDown = e => {
    if (e.keyCode === 13) {
      this.onSubmit()
    }
  }

  onSubmit = () => {
    this.props.onSearch(this.props.value)
  }

  render() {
    return (
      <Container onKeyDown={this.onKeyDown}>
        <Input
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          value={this.props.value}
        />
        <Icon onClick={this.onSubmit} name="search" style={iconStyle} />
      </Container>
    )
  }
}

export default SearchBar
